module.exports = __webpack_public_path__ + "assets/95ba9e388c11d70d597c33a17e65c5c4.svg";